define('components/photoset/item/model',
    [
        'components/photoset/item/states'
    ],

    function (states) {
        const Image = require('models/attachments/image').default;

        function Model(jsonModel) {
            this.index = ko.observable(jsonModel.index).unwrap();
            this.data = ko.observable(jsonModel.data);
            this.template = this.data.mapNotNull(this._getTemplate, this);
            this.state = ko.observable(states.justCreated);

            this._width = ko.pureComputed(function () {
                var width = _(this.data()).result('width', 0),
                    defaultWidth = _(this.data()).result('defaultWidth', 0);

                return width || defaultWidth;
            }, this);

            this._height = ko.pureComputed(function () {
                var width = _(this.data()).result('height', 0),
                    defaultWidth = _(this.data()).result('defaultHeight', 0);

                return width || defaultWidth;
            }, this);

            this.absWidth = this._width;
            this.absHeight = this._height;

            this.relHeight = ko.pureComputed(this._getRelHeight, this);
            this.relWidth = ko.pureComputed(this._getRelWidth, this);

            this.colIdx = ko.observable(null).extend({ deferred: true });
            this.rowIdx = ko.observable(null).extend({ deferred: true });

            this.top = ko.observable(null).extend({ deferred: true });
            this.left = ko.observable(null).extend({ deferred: true });

            this.width = ko.observable(null).extend({ deferred: true });
            this.height = ko.pureComputed(this._getHeight, this).extend({ deferred: true });

            this.showCounter = ko.observable(false).extend({ deferred: true });
            this.isVisible = ko.observable(false).unwrap().default(false);
        }

        Model.prototype._getRelHeight = function () {
            var width = this._width(),
                height = this._height();

            return width > 0 && height > 0 ? height / width : 0;
        };

        Model.prototype._getRelWidth = function () {
            var width = this._width(),
                height = this._height();

            return width > 0 && height > 0 ? width / height : 0;
        };

        Model.prototype._getHeight = function () {
            var width = this.width();

            if (width != null)
                return width.multiply(this.relHeight());

            return null;
        };

        Model.prototype._getTemplate = function (data) {
            if (data instanceof Image) {
                return 'wcc-components-photoset-new-image-and-title';
            } else if (WCC.UserFile != null && data instanceof WCC.UserFile) {
                return 'wcc-components-photoset-new-userfile';
            }

            return 'wcc-components-photoset-new-unknown-item';
        };

        return Model;
    });